// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"styles_Wrapper__19ViJ","WrapperTopIndent":"styles_WrapperTopIndent__1r9g5"};